import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { startsWith } from "lodash-es";
import React from "react";
import drawDirectedPiePiece from "./drawDirectedPiePiece";
import { getInternalLabel } from "./getInternalLabel";
import shouldFlipText from "./shouldFlipText";
export default function Feature(props) {
  const {
    color = "orange",
    radius,
    containsLocations,
    arrowheadLength = 0.5,
    annotationHeight,
    className,
    ellipsizedName,
    annotationType,
    arrowheadType,
    overlapsSelf,
    rotationRadians,
    centerAngle,
    totalAngle,
    opacity,
    locationNumber
  } = props;
  const isPart = annotationType === "part";
  let colorToUse = color;
  if (isPart) {
    colorToUse = startsWith(color, "override_") ? color.replace("override_", "") : "#ac68cc";
  }
  const labelNeedsFlip = shouldFlipText(centerAngle + rotationRadians);
  let path, textPath;
  if (containsLocations) {
    path = drawDirectedPiePiece({
      radius,
      labelNeedsFlip,
      annotationHeight: annotationHeight / 8,
      totalAngle,
      arrowheadLength: 80 / radius,
      tailThickness: 1
      //feature specific
    });
  } else {
    [path, textPath] = drawDirectedPiePiece({
      returnTextPath: true,
      overlapsSelf,
      arrowheadType,
      hasLabel: ellipsizedName,
      labelNeedsFlip,
      radius,
      annotationHeight,
      totalAngle,
      arrowheadLength,
      tailThickness: 1
      //feature specific
    });
  }
  return /* @__PURE__ */ jsx("g", { style: { opacity }, children: containsLocations ? /* @__PURE__ */ jsx(
    "path",
    {
      className,
      strokeWidth: ".5",
      stroke: "black",
      fill: colorToUse,
      d: path.print()
    }
  ) : /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        className,
        strokeWidth: ".5",
        stroke: isPart ? colorToUse : "black",
        fill: isPart ? void 0 : colorToUse,
        d: path.print()
      }
    ),
    getInternalLabel({
      ...props,
      colorToUse,
      textPath,
      isPart,
      locationNumber
    })
  ] }) });
}
